exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".testimonials-outer-box-area .carousel-control-next, .carousel-control-prev{\n    width: auto;\n}\n\n.testimonials-outer-box-area .carousel-control-next span i {\n    background: #f9f7f7;\n    border: 1px solid #c1bdbd;\n    padding: 7px 8px;\n    display: inline-block;\n    color: #adabab;\n    font-size: 30px!important;\n    \n}\n\n.testimonials-outer-box-area .carousel-control-prev span i {\n    background: #f9f7f7;\n    border: 1px solid #c1bdbd;\n    padding: 7px 8px;\n    display: inline-block;\n    color: #adabab;\n    font-size: 30px!important;\n    margin: 0 0 0 -8px;\n}\n\n.testimonial{margin: 0 5px 0px;}\n\n.testimonials-outer-box .row .col-xs-3.col-sm-3.col-md-3 {\n    padding: 0;\n}\n\ni.fa.fa-user-plus {\n    color: #8e8e8e;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/discoverpeople/discoverpeople.component.css
// module id = ../../../../../src/app/home/discoverpeople/discoverpeople.component.css
// module chunks = common